export { getIncrementedName } from '../shared/variables/variableBoxNames';

export const transformDiatricsInsensitive = (text) =>
  text
    ?.toLowerCase()
    .normalize('NFD')
    .replace(/\p{Diacritic}/gu, '');

// Espaces regroupés : le navigateur affiche « Annexes -  La » comme
// « Annexes - La », et c'est ce qu'on tape (noms de section saisis à la main).
const normalizeSearchText = (text) =>
  transformDiatricsInsensitive(String(text ?? ''))
    .replace(/\s+/g, ' ')
    .trim();

export const searchCaseDiatricsInsensitive = (search, text) =>
  normalizeSearchText(text).includes(normalizeSearchText(search));
